import { withStyles } from '@material-ui/core';

import ActionItem from './component';
import styles from './styles';

export default withStyles(styles)(ActionItem);
